<template>
  <div style>
    <el-card class="box-card">
      <div>
        <div class="item">设备编号：{{device.id}}</div>
        <div class="item">设备类型：{{device.typeName}}</div>
        <div class="item">门店名称：{{device.shopName}}</div>
        <div class="item">设备状态：{{device.status==0?"离线":device.status==1?"在线":device.status}}</div>
        <div class="item">
          选择套餐：
          <el-radio
            v-for="item in device.packageList"
            v-bind:key="item.id"
            class="item-radio"
            v-model="device.packageId"
            :label="item.id"
          >{{item.name}}</el-radio>
        </div>
        <div class="item center">
          <el-button type="primary" @click="start">提交订单</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      device: {
        id: null,
        typeName: null,
        shopName: null,
        status: null,
        packageList: [],
        packageId: null
      },
      startSuccess: false
    };
  },
  created: function() {
    let that = this;
    let id = that.$route.query.id;
    if (!id) {
      that.$message({
        message: "设备id不存在请重新扫码！",
        type: "warning",
        duration: 2000,
        onClose: function() {}
      });
    } else {
      this.api.client.getDevice({ id: id }).then(response => {
        if (!response.data.errorCode) {
          Object.assign(that.device, response.data.data);
        }
      });
    }
  },
  methods: {
    start: function() {
      let that = this;
      let id = that.$route.query.id;
      if (!id) {
        that.$message({
          message: "设备id不存在请重新扫码！",
          type: "warning",
          duration: 2000,
          onClose: function() {}
        });
      } else {
        this.api.client
          .createOrder({
            deviceId: that.$route.query.id,
            packageId: that.device.packageId
          })
          .then(response => {
            if (!response.data.errorCode) {
              that.$router.push({
                path: "order",
                query: { id: response.data.data.id }
              });
            }
          });
      }
    }
  }
};
</script>
<style scoped>
.item {
  padding: 12px;
  font-size: 14px;
}
.center {
  text-align: center;
  padding: 30px;
}
.item-radio {
  width: 100%;
  margin-left: 0px;
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// index.vue?538a979d